import { apiClient } from './api';
import { CorrectionRequestService } from './CorrectionRequestServiceBase';
export * from './CorrectionRequestServiceBase';
/** Web correction request service singleton (cookie-auth web client). */
let _webCorrectionRequestService = null;
function getWebCorrectionRequestService() {
    if (!_webCorrectionRequestService) {
        _webCorrectionRequestService = new CorrectionRequestService(apiClient);
    }
    return _webCorrectionRequestService;
}
export const correctionRequestService = getWebCorrectionRequestService();
